<template>
  <transition name="fade">
    <div class="popup" v-if="show">
      <div class="box">{{message}}</div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      message: '',
      duration: 3000,
      show: true,
      dom: null
    }
  },
  watch: {
    show: {
      handler() {
        setTimeout(() => {
          this.show = false
          this.dom && this.dom.remove()
        }, this.duration)
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="less" scoped>
.mw100 {
  min-width: 100px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999999;
  .box {
    max-width: 430px;
    max-height: 200px;
    margin: 0 auto;
    padding: 18px 32px;
    background: #000000;
    border-radius: 10px;
    opacity: 0.8;
    font-size: 30px;
    color: #ffffff;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
